<template>
  <div class="manage-service">
    <a-card
      :bordered="false"
      class="header-solid h-full"
      :bodyStyle="{ paddingTop: 0, paddingBottom: '16px' }"
    >
      <template #title>
        <a-row type="flex" align="middle">
          <h6 class="font-semibold m-0">Danh sách dịch vụ</h6>
          <router-link :to="{ name: 'CreateHomeService' }">
            <a-button type="primary" class="ml-20">Thêm mới</a-button>
          </router-link>
        </a-row>
      </template>
      <a-table
        :loading="callingAPI"
        :columns="columns"
        :data-source="dataSource"
        :pagination="false"
        rowKey="id"
      >
        <template slot="image" slot-scope="row">
          <img
            v-if="row.image"
            :src="row.image"
            alt=""
            class="preview-image-table"
          />
        </template>
        <template slot="active" slot-scope="row">
          <a-switch
            v-model="row.active"
            :loading="row.loadingActive"
            @change="handleUpdate(row)"
          />
        </template>
        <template slot="action" slot-scope="row">
          <a-space>
            <router-link
              :to="{ name: 'UpdateHomeService', params: { id: row.id } }"
            >
              <a-button shape="circle" icon="edit" size="small" />
            </router-link>
            <a-popconfirm
              placement="topRight"
              ok-text="Xóa"
              cancel-text="Hủy"
              @confirm="removeService(row)"
            >
              <template slot="title">
                <p>Xóa dịch vụ {{ row.name }} ??</p>
              </template>
              <a-button
                type="danger"
                shape="circle"
                icon="delete"
                size="small"
              />
            </a-popconfirm>
          </a-space>
        </template>
      </a-table>
    </a-card>
  </div>
</template>

<script>
import {fetchService, updateService, deleteService} from '@/services/landing-page/home/service'
  export default {
    name: 'ManageService',
    data() {
      return {
        callingAPI: false,
        dataSource: [],
        columns: [
          {
            title: 'Tên',
            dataIndex: 'name',
            scopedSlots: { customRender: 'name' },
            class: 'font-semibold',
          },
          {
            title: 'Mô tả',
            dataIndex: 'description',
            scopedSlots: { customRender: 'description' },
          },
          {
            title: 'Ảnh',
            scopedSlots: { customRender: 'image' },
            width: 150,
          },
          {
            title: 'Hiển thị',
            scopedSlots: { customRender: 'active' },
            width: 100,
          },
          {
            title: '',
            scopedSlots: { customRender: 'action' },
            width: 50,
          },
        ],
      }
    },
    async beforeMount() {
      await this.loadData()
    },
    methods: {
      async loadData(page = 1) {
        try {
          this.callingAPI = true
          const response = await fetchService()
          console.log(response)
          this.dataSource = response.data.map((d) => ({
            ...d,
            image: `${process.env.VUE_APP_LANDING_PAGE_BACKEND_URL}/${d.photo_url}`,
            active: d.active === 1,
            loadingActive: false
          }))
          this.callingAPI = false
        } catch (error) {
          this.callingAPI = false
        }
      },

      async handleUpdate(row) {
        const index = this.dataSource.findIndex((r) => r.id === row.id)
        this.dataSource[index].loadingActive = true
        try {
          const data = {
            ...row,
            active: row.active ? 1 : 2
          }
          delete data.id
          const response = await updateService(row.id, data)
          this.dataSource[index].loadingActive = false
          if (response.status === 1) {
            this.$notification.success({
              message: 'Thành công',
              description: 'Cập nhật trạng thái hiển thị thành công.',
            });
          } else {
            this.$notification.error({
              message: 'Thất bại',
              description: 'Cập nhật trạng thái hiển thị thất bại.',
            });
          }
        } catch (error) {
          this.dataSource[index].loadingActive = false
        }
      },

      async removeService(row) {
        try {
          this.callingAPI = true
          const response = await deleteService(row.id)
          if (response.status === 1) {
            this.$notification.success({
              message: 'Thành công',
              description: 'Xóa dịch vụ thành công',
            });
          } else {
            this.$notification.error({
              message: 'Thất bại',
              description: 'Xóa dịch vụ thất bại',
            });
          }
          await this.loadData()
          this.callingAPI = false
        } catch (error) {
          this.callingAPI = false
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>